import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  private rsaPublicKey = '';
  
  private initializationPromise: Promise<void> | null = null;
  private isTokenReady$ = new BehaviorSubject<boolean>(false);
  
  // El interceptor usa esto para pausar peticiones hasta tener la llave
  public isTokenReady = this.isTokenReady$.asObservable();

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    // Al instanciar el servicio (cuando carga la web), pedimos la llave directamente.
    // Al guardarla solo en memoria, nadie la verá en F12 -> LocalStorage.
    if (isPlatformBrowser(this.platformId)) {
      this.initializeSession();
    } else {
      this.isTokenReady$.next(true); // Evitar bloqueos en SSR
    }
  }

  public initializeSession(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      this.isTokenReady$.next(true);
      return Promise.resolve();
    }

    if (this.initializationPromise) {
      return this.initializationPromise;
    }

    this.initializationPromise = this.doInitializeSession()
      .finally(() => {
        this.initializationPromise = null;
      });

    return this.initializationPromise;
  }

  private async doInitializeSession(): Promise<void> {
    // Bypass temporal: no hacer la petición para la llave pública
    this.isTokenReady$.next(true);
    return;

    /* Código original:
    try {
      const response = await this.http.get<{ publicKey: string; domain: string }>(`${this.apiUrl}auth/public-key`).toPromise();
      
      if (response && response.publicKey) {
        this.rsaPublicKey = response.publicKey;
        this.isTokenReady$.next(true);
      } else {
        throw new Error("No se recibió la llave pública.");
      }

    } catch (error) {
      console.error('Error inicializando llave pública:', error);
      setTimeout(() => this.initializeSession(), 5000);
      throw error;
    }
    */
  }

  public getPublicKey(): string {
    return this.rsaPublicKey;
  }

  /**
   * Borra la llave actual y la vuelve a pedir.
   */
  public forceRefreshSession(): Promise<void> {
    this.rsaPublicKey = '';
    this.isTokenReady$.next(false);
    return this.initializeSession();
  }
}
